import React from 'react'
import { StyleSheet } from 'react-native'
import { Color, Text } from 'zens-storybook'
import { useCountry, useLocation } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    color: Color.modifiedGrey,
  },
})

interface Props {
  value: number
  companyId: number
}
const LocationAddress = (props: Props) => {
  const { value: locationId, companyId } = props
  const location = useLocation({
    companyId,
    locationId,
  })
  const country = useCountry({
    lat: location.data?.latitude || 0,
    lng: location.data?.longitude || 0,
  })
  return (
    <Text level={5} style={styles.container}>
      {location.data?.displayAddress},{' '}
      <Text level={5} style={styles.container}>
        {country.data?.title}
      </Text>
    </Text>
  )
}

export default LocationAddress
